import { render, staticRenderFns } from "./MobileStepHeader.vue?vue&type=template&id=4c530d6e&scoped=true&"
import script from "./MobileStepHeader.vue?vue&type=script&lang=js&"
export * from "./MobileStepHeader.vue?vue&type=script&lang=js&"
import style0 from "./MobileStepHeader.vue?vue&type=style&index=0&id=4c530d6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c530d6e",
  null
  
)

export default component.exports